import { contracts } from 'locales/ja/contracts';
import type { PageType } from 'types/page_type';

export const contractsPage: Readonly<PageType> = {
  path: '/contracts',
  title: `${contracts.resourceName}履歴`,
  description: `${contracts.resourceName}履歴`,
};

export const contractsShowPage: Readonly<PageType> = {
  path: `${contractsPage.path}/{id}`,
  title: `${contracts.resourceName}内容詳細`,
  description: `${contracts.resourceName}内容詳細`,
};

export const contractsShowPagePath = (
  id: number | string | undefined
): string => {
  if (!id) return '#';

  return `${contractsPage.path}/${id}`;
};

export const contractsShowPageTitle = (
  status: 'pending' | 'approved' | 'rejected' | undefined
): string => {
  if (!status) return '';

  return status === 'pending'
    ? `${contracts.resourceName}内容の確認`
    : `${contracts.resourceName}内容詳細`;
};

export const contractsShowPageDescription = (
  status: 'pending' | 'approved' | 'rejected' | undefined
  // eslint-disable-next-line sonarjs/no-identical-functions
): string => {
  if (!status) return '';

  return status === 'pending'
    ? `${contracts.resourceName}内容の確認`
    : `${contracts.resourceName}内容詳細`;
};

export const contractsLicensesShowPage: Readonly<PageType> = {
  path: contractsPage.path,
  title: '提供サービス詳細',
  description: '提供サービス詳細',
};

export const contractsLicensesShowPagePath = (
  contractId: number | string | undefined,
  licenseId: number | string | undefined
): string => {
  if (!contractId) return '#';
  if (!licenseId) return '#';

  return `${contractsPage.path}/${contractId}/licenses/${licenseId}`;
};
